import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Button from '@base/Button/Button';
import H4 from '@base/H4/H4';
import TextField from '@base/TextField/TextField';
import { Spacings, Fonts } from '@styles/index';
import useInviteCode from './useInviteCode';

const Title = styled(H4)`
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

const StyledBtn = styled(Button)`
  margin-top: ${Spacings.SPACING_10B};
  background-image: ${({ $isEnabled }) =>
    $isEnabled
      ? 'linear-gradient(180deg, var(--color-i-blue-4) 0%, var(--color-i-blue-3) 100%);'
      : 'none'};
`;

const StyledTextField = styled(TextField)`
  margin-top: ${Spacings.SPACING_6B};
`;

const InviteCodeStep = ({ enroll }) => {
  const {
    inviteCode,
    onInviteCodeChange,
    error,
    onEnroll,
    INVALID_INVITE_CODE,
    isEnrollButtonEnabled
  } = useInviteCode({ enroll });
  return (
    <>
      <Title>You need an invite code to enroll in this contest</Title>
      <StyledTextField
        fullWidth
        value={inviteCode}
        type="text"
        placeholder="Enter Invite code"
        onChange={onInviteCodeChange}
        error={error?.error_code === INVALID_INVITE_CODE.error_code}
        helperText={
          error?.error_code === INVALID_INVITE_CODE.error_code
            ? error?.message
            : ''
        }
        autoFocus
      />
      <StyledBtn
        label="Enroll now"
        variant={isEnrollButtonEnabled ? 'filled' : 'disabled'}
        $isEnabled={isEnrollButtonEnabled}
        onClick={onEnroll}
      />
    </>
  );
};

InviteCodeStep.propTypes = {
  enroll: PropTypes.func.isRequired
};

export default InviteCodeStep;
